import { render, staticRenderFns } from "./provisional-fee-list.vue?vue&type=template&id=abfd312a&"
import script from "./provisional-fee-list.vue?vue&type=script&lang=ts&"
export * from "./provisional-fee-list.vue?vue&type=script&lang=ts&"
import style0 from "./provisional-fee-list.vue?vue&type=style&index=0&id=abfd312a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports